import { Route } from '@angular/router';

export const parkingManagementRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'menu',
    pathMatch: 'full',
  },
  {
    path: 'menu',
    loadComponent: () => import('./pages').then(p => p.ParkingManagementMenuComponent),
    title: 'UIMS - Parking Management',
  },
  {
    path: ':id/session-list',
    loadComponent: () => import('./pages').then(p => p.ParkingManagementListComponent),
    title: 'UIMS - Parking Sessions',
  },
  {
    path: ':id/session-list/:sessionId',
    loadComponent: () => import('./pages').then(p => p.ParkingSessionDetailsComponent),
    title: 'UIMS - Parking Session Details',
  },
];
